"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfilesManager = void 0;
var tslib_1 = require("tslib");
var firestoreProfiles_1 = require("./firestoreProfiles");
var ProfilesManager = /** @class */ (function () {
    function ProfilesManager() {
        this.profilesManager = new firestoreProfiles_1.FireStoreProfilesManager();
    }
    ProfilesManager.prototype.userHasProfiles = function (userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.profilesManager.userHasProfiles(userId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ProfilesManager.prototype.createProfile = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.profilesManager.createProfile(params)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ProfilesManager.prototype.updateProfile = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.profilesManager.updateProfile(params)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ProfilesManager.prototype.getProfiles = function (userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.profilesManager.getProfiles(userId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ProfilesManager.prototype.getProfile = function (userId, profileId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.profilesManager.getProfile(userId, profileId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ProfilesManager.prototype.deleteProfile = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.profilesManager.deleteProfile(params)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ProfilesManager.prototype.getUserProfilesRef = function (userId) {
        return this.profilesManager.getUserProfilesRef(userId);
    };
    ProfilesManager.prototype.onUserProfilesSnapshot = function (userId, callback) {
        return this.profilesManager.onUserProfilesSnapshot(userId, callback);
    };
    return ProfilesManager;
}());
exports.ProfilesManager = ProfilesManager;
